<template>
  <CodeInput
    v-model="model"
    class="verfication-code-field"
    :error="!!error"
    v-bind="$attrs"
    @input="onInput"
    @blur="onBlur"
  />
  <p
    class="verfication-code-field-error"
    v-if="error"
  >
    <i class="verfication-code-field-error__icon" />
    {{ error }}
  </p>
</template>

<script setup>
import CodeInput from '../CodeInput/index.vue'

const model = defineModel({ type: String })
const error = ref('')

const onInput = () => {
  error.value = null
}

const onBlur = () => {
  if (model.value === '' || model.value == null) {
    error.value = 'The verification code is required.'
  } else if (model.value.length !== 6) {
    error.value = 'Please enter a 6-digit verification code.'
  } else {
    error.value = null
  }
}
</script>

<style lang="less" scoped>
.verfication-code-field {
  &-error {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: mon-500;
    font-size: 10px;
    color: #F53131;
  }
}
</style>
